<template>
	<div class="check u-flex-col u-col-center u-row-center">
		<img src="../assets/imgs/index1-2.png" class="about-bg" alt="">
		<div class="check-box u-flex-col u-col-center u-row-center">
			<!-- <img src="../assets/imgs/check1-1.png" class="top-img" alt=""> -->
			<div class="title fadeInUp animated">
				{{$t('防伪检测查询')}}
			</div>
			<!-- <div class="tips">
				{{$t('输入防伪码')}}
			</div> -->
			<div style="position: relative;" class="fadeInUp animated">
				<input type="text" class="code-input" :placeholder="$t('输入20位数的纯数字检查')" v-model="code">
				<div class="query" @click="chaxun">{{$t('查询')}}</div>
			</div>
			<div class="down-butt u-flex u-col-center u-row-between">
				<div class="error-box u-flex u-col-center" style="flex: 1;" v-if="showstatus == 1 && result">
					<img src="../assets/imgs/check1-3.png" alt="">
					<span style="color: #16CD61;flex: 1;">{{$t('您好，您所查询的是由巴博斯品牌生产的德国手表，该产品经验证为正品。')}}</span>
				</div>
				<div class="error-box u-flex u-col-center" v-else-if="showstatus == 1 && !result">
					<img src="../assets/imgs/check1-2.png" alt="">
					<span>{{$t('查询不存在，请核实防伪码')}}</span>
				</div>
				<span v-else></span>
				<!-- <span class="query" @click="chaxun">{{$t('查询')}}</span> -->
			</div>
			<div class="h5-query fadeInUp animated" :class="code ? 'h5-query1' : ''" @click="chaxun">{{$t('查询')}}</div>
		</div>
		<div v-if="showstatus == 1" class="check-over u-flex-col u-col-center">
			<img src="../assets/imgs/check1-3.png" alt="" v-if="result">
			<span class="span1" style="color: #16CD61;text-align: center;" v-if="result">{{$t('您好，您所查询的是由巴博斯品牌生产的德国手表，该产品经验证为正品。')}}</span>
			<img src="../assets/imgs/check1-2.png" alt="" v-if="!result">
			<span class="span1" style="color: #FF5656;" v-if="!result">{{$t('查询不存在，请核实防伪码')}}</span>
			<span class="span2" @click="showstatus = 0">{{$t('重新检测')}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				code: '',
				showstatus: 0,
				result: false,
				message:''
			}
		},
		mounted() {
			this.$parent.settitle(this.$t('防伪检测'))
		},
		methods: {
			chaxun() {
				/* if (this.code.length != 20) {
					this.$message.error(this.$t('输入20位纯数字校验'))
					return
				} */
				this.$http.get('/api/Index/authenticityTesting/' + this.code).then(res => {
					if (res.code == 200) {
						this.code = ''
						this.showstatus = 1
						this.result = res.result
						this.message = res.message
					}
				})
			}
		}
	}
</script>

<style lang="scss">
  .fadeInUp {
		-webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
		visibility: visible;
	}
	.animated {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
	}
	@keyframes fadeInUp {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0,100%,0);
			transform: translate3d(0,100%,0);
		}
		100% {
			opacity: 1;
			-webkit-transform: none;
			transform: none;
		}
	}
</style>
